import React, { useEffect, useState } from 'react';
import II18 from '../translate/II18';
import {
  BlockTitle,
  Card,
  CardContent,
  List,
  ListItem,
  Link,
  Popover,
  Icon,
  f7
} from 'framework7-react';
import PropTypes from 'prop-types';
import { getStandaloneDraft } from '../../lib/standaloneDraftCache';

const TEMPLATE_MENU_ID = 'template-menu';
const PLAY_COLOR_DEFAULT = 'blue';
const PLAY_COLOR_DRAFT = 'green';

/**
 * TemplatesList
 *
 * @param {{ usedTemplates, startTemplate, removeTemplates }} props
 * @returns {JSX.Element}
 */
export default function TemplatesList(props) {
  const {
    usedTemplates,
    startTemplate,
    removeTemplates,
    draftVersion = 0
  } = props;
  const [menuTemplateId, setMenuTemplateId] = useState(null);
  const [draftTemplateId, setDraftTemplateId] = useState(null);

  useEffect(() => {
    if (!window.standalone) {
      setDraftTemplateId(null);
      return;
    }

    getStandaloneDraft().then(draft => {
      setDraftTemplateId(draft?.templateId || null);
    });
  }, [usedTemplates, draftVersion]);

  const openTemplateMenu = id => {
    setMenuTemplateId(id);
    f7.popover.open('#' + TEMPLATE_MENU_ID, '#templateMenuBtn_' + id);
  };

  const deleteTemplate = () => {
    const id = menuTemplateId;
    if (!id) return;

    f7.popover.close('#' + TEMPLATE_MENU_ID);
    setMenuTemplateId(null);
    setTimeout(() => removeTemplates([id]), 150);
  };

  const restartTemplate = () => {
    const id = menuTemplateId;
    if (!id) return;

    f7.popover.close('#' + TEMPLATE_MENU_ID);
    setMenuTemplateId(null);
    setTimeout(() => startTemplate(id, { fresh: true }), 150);
  };

  const showRestartMenuItem =
    menuTemplateId && draftTemplateId === menuTemplateId;

  return (
    <>
      <BlockTitle>
        <II18>recent_templates</II18>
      </BlockTitle>
      <Card>
        <CardContent>
          <List inset className={'templates-list'}>
            {usedTemplates.map(item => (
              <ListItem key={item.id}>
                <label slot={'title'} onClick={() => startTemplate(item.id)}>
                  {item.name}
                </label>
                <Link
                  slot="after"
                  id={'templateMenuBtn_' + item.id}
                  color={'gray'}
                  iconMaterial="more_vert"
                  onClick={() => openTemplateMenu(item.id)}
                  href={false}
                />
                <Link
                  slot="media"
                  color={
                    draftTemplateId === item.id
                      ? PLAY_COLOR_DRAFT
                      : PLAY_COLOR_DEFAULT
                  }
                  iconMaterial="play_circle_filled"
                  onClick={() => startTemplate(item.id)}
                />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
      <Popover id={TEMPLATE_MENU_ID}>
        <List>
          {showRestartMenuItem && (
            <ListItem
              popoverClose
              title={II18.get('standalone_draft_restart')}
              onClick={restartTemplate}
            >
              <Icon slot="after" material="refresh" />
            </ListItem>
          )}
          <ListItem
            popoverClose
            title={II18.get('qr_start_delete_one_template')}
            onClick={deleteTemplate}
          >
            <Icon slot="after" material="delete" color="red" />
          </ListItem>
        </List>
      </Popover>
    </>
  );
}

TemplatesList.propTypes = {
  usedTemplates: PropTypes.array,
  hasOriginalUsedTemplates: PropTypes.bool,
  startTemplate: PropTypes.func,
  removeTemplates: PropTypes.func,
  draftVersion: PropTypes.number
};
